import { Dialog, DialogContent } from "@mui/material";
import { Stack } from "@mui/system";
import moment from "moment";
import { TitleAndDetailsView } from "../../../molecules";
import { DialogTitle } from "../../../atoms";
import { useCouponModalState } from "./useCouponModalState";

function CouponInfoModal({}) {
  const { coupon, handleClose } = useCouponModalState();
  return (
    <Dialog open maxWidth={"xs"}>
      <DialogTitle title="Coupon Details" handleClose={handleClose} />
      <DialogContent>
        <Stack spacing={3}>
          <TitleAndDetailsView title="Code" details={coupon?.code} />
          <TitleAndDetailsView title="Category" details={coupon?.type} />
          <TitleAndDetailsView title="Value" details={`${coupon?.value}%`} />
          <TitleAndDetailsView title="Min Cap" details={coupon?.minimumCap} />
          <TitleAndDetailsView title="Max Cap" details={coupon?.maximumCap} />
          <TitleAndDetailsView title="Status" details={coupon?.isActive ? "Active" : "Inactive"} />
          <TitleAndDetailsView title="Start Date" details={moment(coupon?.startDate).format("DD.MM.YYYY")} />
          <TitleAndDetailsView title="Expiry Date" details={moment(coupon?.expiryDate).format("DD.MM.YYYY")} />
          <TitleAndDetailsView title="Total Usage of Code" details={coupon?.totalUsage} />
          <TitleAndDetailsView title="Usage per User" details={coupon?.usagePerUser} />
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default CouponInfoModal;
